module.exports = __webpack_public_path__ + "img/browserlogo.4de526df.png";